import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";

const WhatAreOecdGuide = () => {
  const urlConfig = {
    name: "OECD.zip",
    downloadUrl: "https://demo.sustainesg.ca/pdf/OECDGuideline.zip",
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="OECD Guidelines"
            title={"OECD Reporting"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: "8px",
            padding: "24px",
            top: "226px",
            left: "75px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#2E7D32",
              mb: 3,
              fontFamily: "DM Sans",
              fontSize: "40px",
              lineHeight: "38px",
            }}
          >
            The global standards for sustainability
            <br /> impacts
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography
              component="h4"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 800,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 1,
              }}
            >
              What Are the OECD Guidelines?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              The OECD Guidelines for Multinational Enterprises are a set of
              voluntary principles and standards issued by the Organisation for
              Economic Co-operation and Development (OECD) to promote
              responsible business conduct globally.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              These guidelines provide recommendations addressed to
              multinational enterprises (MNEs), covering areas such as:
            </Typography>
            <Box component="ul" sx={{ pl: 4, mb: 2 }}>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Human rights
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Labor rights and industrial relations
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Environment
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Combating bribery and corruption
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Consumer interests
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Science and technology
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Competition
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Taxation
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Disclosure and transparency
              </Typography>
            </Box>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              The purpose of the OECD Guidelines is to ensure that multinational
              companies operate in a way that contributes to sustainable
              development, respects stakeholder rights, and aligns with
              internationally recognized standards.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              The OECD Guidelines help businesses integrate ethical, social, and
              environmental considerations into their global operations, supply
              chains, and decision-making processes.
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* <a
            href="https://www.oecd.org/corporate/mne/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <CustomButton title="Access Full OECD Guidelines Documentation" />
          </a> */}

          <DownloadZipButton
            config={urlConfig}
            title="Access Full OECD Guidelines Documentation"
            externalHref="https://www.oecd.org/corporate/mne/"
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default WhatAreOecdGuide;
